import SignUpContext from '@activities/auth/SignUpActivity/context/SignUpContext';
import { ReactNode, useEffect, useState } from 'react';

interface Props {
    children?: ReactNode;
    kakaoId?: number;
    nickname?: string;
    appleId?: string;
    googleId?: string;
}

function SignUpContextProvider({
    children, kakaoId, nickname, appleId, googleId,
}:Props) {
    const useVerified = useState<boolean>(false);
    const useValue = useState<string>('');
    const useMarketing = useState<boolean>(false);
    const useLocation = useState<boolean>(false);
    const useInputValue = useState<string>('');
    const useInputAuthCode = useState<string>('');
    const useSelectedTermCategories = useState<string[]>([]);
    const [value] = useValue;
    const [inputValue] = useInputValue;
    const [verified] = useVerified;
    const [inputAuthCode] = useInputAuthCode;
    useEffect(() => {
        console.log({
            value, inputValue, verified, inputAuthCode,
        });
    }, [value, inputValue, verified, inputAuthCode]);
    return (
        <SignUpContext value={{
            useVerified,
            useValue,
            useMarketing,
            useLocation,
            useInputValue,
            useInputAuthCode,
            useSelectedTermCategories,
            kakaoId,
            nickname,
            appleId,
            googleId,
        }}>
            {children}
        </SignUpContext>
    );
}

export default SignUpContextProvider;
